import React, { useState } from 'react';
import styles from './Tooltip.module.css';

const Tooltip = ({
  content,
  children,
  position = 'top',
  delay = 300,
  className = '',
  disabled = false
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const showTooltip = () => {
    if (disabled) return;
    
    const id = setTimeout(() => {
      setIsVisible(true);
    }, delay);
    setTimeoutId(id);
  };

  const hideTooltip = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    setIsVisible(false);
  };

  const getTooltipClasses = () => {
    const baseClasses = [styles.tooltip];
    baseClasses.push(styles[`tooltip--${position}`]);
    if (isVisible) baseClasses.push(styles['tooltip--visible']);
    if (className) baseClasses.push(className);
    return baseClasses.join(' ');
  };

  return (
    <div
      className={styles.tooltipContainer}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      onFocus={showTooltip}
      onBlur={hideTooltip}
    >
      {children}
      <div className={getTooltipClasses()}>
        <div className={styles.tooltipContent}>
          {content}
        </div>
        <div className={styles.tooltipArrow} />
      </div>
    </div>
  );
};

export default Tooltip;